import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Importar utilidades para notificaciones
import './utils/notificationFixer';
import './utils/adminRoleFixer';
import './utils/autoAdminDetection';
import { detectAdminsByRole, ensureAdminRole } from './utils/adminNotificationSystem';

// Inicializar sistema de notificaciones basado en roles
const initNotificationSystem = async () => {
  try {
    console.log('🚀 Inicializando sistema de notificaciones basado en roles...');
    
    // Detectar administradores por rol
    const adminIds = await detectAdminsByRole();
    console.log(`👥 Administradores detectados: ${adminIds.length}`);
    
    // Asegurar que el administrador de fallback tenga rol admin
    const fallbackAdminId = process.env.REACT_APP_FALLBACK_ADMIN_UID;
    if (fallbackAdminId) {
      console.log('🔧 Configurando administrador de fallback:', fallbackAdminId);
      await ensureAdminRole(fallbackAdminId);
    }
    
    console.log('✅ Sistema de notificaciones inicializado correctamente');
  } catch (error) {
    console.error('❌ Error inicializando sistema de notificaciones:', error);
  }
};

// Inicializar sistema de notificaciones
initNotificationSystem();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
